import { get } from '../helper/API';

export function getUserAuditionByUserAuditionUuid(userAuditionUuid) {
    return get(`employer/user-auditions/${userAuditionUuid}`);
}

export function getAuditionByUserAuditionUuid(userAuditionUuid) {
    return get(`employer/audition-by-user-audition/${userAuditionUuid}`);
}
